module.exports = __webpack_public_path__ + "static/media/zurich.03e0f0b6.png";